const pending = new Map<string, Promise<void>>()

export function loadScript(
  id: string,
  src: string,
  attributes: Readonly<Record<string, string>> = {},
): Promise<void> {
  const known = pending.get(id)
  if (known !== undefined) {
    return known
  }

  const promise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script')
    script.id = id
    script.async = true
    script.src = src
    for (const [name, value] of Object.entries(attributes)) {
      script.setAttribute(name, value)
    }
    script.onload = () => resolve()
    script.onerror = () => {
      pending.delete(id)
      script.remove()
      reject(new Error(`Analytics script failed to load: ${id}`))
    }
    document.head.appendChild(script)
  })
  pending.set(id, promise)

  return promise
}

export function removeScript(id: string): void {
  pending.delete(id)
  document.getElementById(id)?.remove()
}

export function deleteCookiesByPrefix(prefixes: readonly string[]): void {
  const hostname = window.location.hostname
  const domains = ['', `; domain=${hostname}`, `; domain=.${hostname}`]
  for (const entry of document.cookie.split(';')) {
    const name = entry.split('=')[0]?.trim() ?? ''
    if (name === '' || !prefixes.some((prefix) => name.startsWith(prefix))) {
      continue
    }
    for (const domain of domains) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domain}`
    }
  }
}
